import React, { useEffect, useContext, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import './PaymentStatus.css';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import Cookies from 'js-cookie';

const Success = () => {
    const history = useHistory();
    const { refreshSubscription } = useContext(SubscriptionContext);
    const [countdown, setCountdown] = useState(10);
    const redirectedManually = useRef(false);
    const hasRedirected = useRef(false); // Additional protection
    const subscriptionRefreshed = useRef(false); // Track if subscription was refreshed

    useEffect(() => {
        let mounted = true;

        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev === 1) clearInterval(timer);
                return prev - 1;
            });
        }, 1000);

        const handleSubscription = async () => {
            try {
                await new Promise(resolve => setTimeout(resolve, 10000));

                // Multiple checks to prevent duplicate actions
                if (!redirectedManually.current && !hasRedirected.current && mounted) {
                    if (!subscriptionRefreshed.current) {
                        subscriptionRefreshed.current = true;
                        await refreshSubscription();
                        Cookies.set('questionsPracticed', 0);
                    }

                    if (!hasRedirected.current) {
                        hasRedirected.current = true;
                        history.push('/practiceevents');
                    }
                }
            } catch (error) {
                console.error("Error refreshing subscription:", error);
            }
        };

        handleSubscription();

        return () => {
            mounted = false;
            clearInterval(timer);
        };
    }, []); // Remove refreshSubscription from dependencies to prevent re-runs

    const handleManualRedirect = () => {
        if (!hasRedirected.current) {
            redirectedManually.current = true;
            hasRedirected.current = true;
            history.push('/practiceevents');
        }
    };

    return (
        <div className="status-container success">
            <div className="animation-section">
                <div className="circle-bg"></div>
                <div className="checkmark">&#10003;</div>
            </div>

            <h1>Payment Confirmed</h1>
            <p>Your service plan is now active.</p>
            <p>Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...</p>

            <button className="dashboard-btn" onClick={handleManualRedirect}>
                Go to Practice now
            </button>
        </div>
    );
};

export default Success;
